<template>
  <div v-if="show_builder" id="builder">
    <Overlay />
    <Sidebar />
    <Preview />
    <div class="desktop-togglers">
      <button class="confirm-toggler" @click="confirm_selection">
        Confirm Selection
      </button>
      <button
        class="fullscreen-toggler main"
        :class="{ shown: should_fullscreen_show }"
        @click="go_fullscreen"
      >
        <svg
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 298.667 298.667"
          style="enable-background:new 0 0 298.667 298.667;"
          xml:space="preserve"
        >
          <polygon
            fill="#fff"
            points="42.667,192 0,192 0,298.667 106.667,298.667 106.667,256 42.667,256"
          />
          <polygon
            fill="#fff"
            points="0,106.667 42.667,106.667 42.667,42.667 106.667,42.667 106.667,0 0,0"
          />
          <polygon
            fill="#fff"
            points="192,0 192,42.667 256,42.667 256,106.667 298.667,106.667 298.667,0"
          />
          <polygon
            fill="#fff"
            points="256,256 192,256 192,298.667 298.667,298.667 298.667,192 256,192"
          />
        </svg>
      </button>
    </div>
    <modal v-if="show_confirm_modal" @close="show_confirm_modal = false">
      <h3 slot="header">Order Confirmed</h3>
      <p slot="body">{{ social.modal_message }}</p>
      <div class="social" slot="body">
        <h5>Share Design</h5>
        <SidebarSocialShare />
      </div>
    </modal>
  </div>
  <Preloader v-else-if="show_preloader" />
  <div class="lost" v-else-if="is_configurator_undefined">
    The configurator
    <strong>{{ $route.params.type }}</strong> you're looking for is not
    available
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { EventBus } from '@/eventBus';
import Sidebar from '@/components/Sidebar';
import Preview from '@/components/Preview';
import Preloader from '@/components/Preloader';
import Overlay from '@/components/Overlay';
import fscreen from 'fscreen';
import Modal from '@/components/Modal';
import SidebarSocialShare from '@/components/Sidebar/SidebarSocialShare';

export default {
  name: 'app',
  components: {
    Sidebar,
    Preview,
    Preloader,
    Overlay,
    Modal,
    SidebarSocialShare,
  },
  data() {
    return {
      show_confirm_modal: false,
    };
  },
  computed: {
    ...mapGetters([
      'configurator',
      'has_configurator',
      'has_preloaded',
      'social',
    ]),
    is_configurator_undefined() {
      return (
        typeof this.configurator === 'undefined' ||
        !Object.keys(this.configurator).length
      );
    },
    show_preloader() {
      return this.has_configurator && !this.is_configurator_undefined;
    },
    show_builder() {
      return (
        this.has_configurator &&
        this.has_preloaded &&
        !this.is_configurator_undefined
      );
    },
    should_fullscreen_show() {
      return fscreen.fullscreenEnabled;
    },
  },
  mounted() {
    const interval = setInterval(() => {
      this.fetch_data();
      if (!this.is_configurator_undefined) {
        clearInterval(interval);
      }
    }, 1);

    EventBus.$on('confirm', () => {
      this.show_confirm_modal = true;
    });
  },
  methods: {
    fetch_data() {
      this.$store.dispatch('set_configurator', {
        type: this.$route.params.type,
        base: this.$route.params.base,
        overlay: this.$route.params.overlay,
      });

      if (!this.is_configurator_undefined && !this.configurator.preloaded)
        this.$store.commit('SET_APP_PRELOADED', false);

      this.$store.commit('SET_TYPE', this.$route.params.type);
    },
    go_fullscreen() {
      if (fscreen.fullscreenElement) fscreen.exitFullscreen();
      else fscreen.requestFullscreen(document.getElementById('app'));
    },
    confirm_selection() {
      this.show_confirm_modal = !this.show_confirm_modal;
      EventBus.$emit('social');
    },
  },
  watch: {
    $route: 'fetch_data',
  },
};
</script>
